import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const footerSections = [
    {
      title: 'For Couples',
      links: [
        { label: 'Find Vendors', path: '/category-browse' },
        { label: 'All Vendors', path: '/all-vendors' },
        { label: 'Browse Categories', path: '/browse-categories-all-vendor-types' },
        { label: 'Planning Tools', path: '/planning-tools' },
        { label: 'Budget Calculator', path: '/planning-tools/budget-calculator' },
        { label: 'Wedding Checklist', path: '/planning-tools/checklist' },
        { label: 'User Dashboard', path: '/user-dashboard' },
        { label: 'Wedding Planning Tools', path: '/user-dashboard-wedding-planning-tools' },
        { label: 'Clean Mobile Dashboard', path: '/user-dashboard-clean-mobile-layout' }
      ]
    },
    {
      title: 'For Vendors',
      links: [
        { label: 'Join as Vendor', path: '/vendor-registration' },
        { label: 'Vendor Dashboard', path: '/vendor-dashboard' },
        { label: 'Browse Vendors', path: '/all-vendors' }
      ]
    },
    {
      title: 'Account & Auth',
      links: [
        { label: 'Sign In', path: '/sign-in-page' },
        { label: 'Sign Up', path: '/sign-up-page' },
        { label: 'Login', path: '/login' },
        { label: 'Signup', path: '/signup' }
      ]
    },
    {
      title: 'Company Info',
      links: [
        { label: 'About Us', path: '/about-us' },
        { label: 'Contact Us', path: '/contact-us' },
        { label: 'Careers', path: '/careers' },
        { label: 'Site Map', path: '/sitemap' }
      ]
    },
    {
      title: 'Support & Legal',
      links: [
        { label: 'Help Center', path: '/help-center' },
        { label: 'Privacy Policy', path: '/privacy-policy' },
        { label: 'Terms of Service', path: '/terms-of-service' }
      ]
    },
    {
      title: 'Admin & System',
      links: [
        { label: 'Admin Dashboard', path: '/admin-dashboard' },
        { label: 'Design System', path: '/design-system-update' }
      ]
    }
  ];

  const socialLinks = [
    { name: 'Facebook', icon: 'Facebook', href: '#' },
    { name: 'Instagram', icon: 'Instagram', href: '#' },
    { name: 'Twitter', icon: 'Twitter', href: '#' },
    { name: 'YouTube', icon: 'Youtube', href: '#' }
  ];

  return (
    <footer className="bg-surface-100 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 lg:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
            {/* Brand Section */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center space-x-3 mb-6">
                <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-primary to-primary-600 rounded-lg shadow-soft">
                  <Icon name="Heart" size={24} color="#FFFFFF" strokeWidth={2.5} />
                </div>
                <div className="flex flex-col">
                  <span className="font-heading font-bold text-xl text-primary tracking-tight">
                    ShaadiNest
                  </span>
                  <span className="font-caption text-xs text-text-secondary -mt-1">
                    Wedding Marketplace
                  </span>
                </div>
              </Link>

              <p className="text-text-secondary font-body mb-6 max-w-md">
                Connecting couples with authentic South Asian wedding vendors across the United States.
                Your dream wedding starts here.
              </p>

              {/* Social Links */}
              <div className="flex items-center space-x-4">
                {socialLinks?.map((social) => (
                  <a
                    key={social?.name}
                    href={social?.href}
                    className="flex items-center justify-center w-10 h-10 bg-white border border-border rounded-lg text-text-secondary hover:text-primary hover:border-primary-200 hover:bg-primary-50 transition-all duration-200"
                    aria-label={`Follow us on ${social?.name}`}
                  >
                    <Icon name={social?.icon} size={18} />
                  </a>
                ))}
              </div>
            </div>

            {/* Footer Links */}
            {footerSections?.map((section) => (
              <div key={section?.title}>
                <h3 className="font-heading font-semibold text-text-primary mb-4">
                  {section?.title}
                </h3>
                <ul className="space-y-3">
                  {section?.links?.map((link) => (
                    <li key={link?.label}>
                      <Link
                        to={link?.path}
                        className="text-text-secondary hover:text-primary font-body text-sm transition-colors duration-200"
                      >
                        {link?.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-6 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="flex items-center space-x-6">
              <p className="text-text-secondary text-sm font-body">
                © 2024 ShaadiNest. All rights reserved.
              </p>
              <div className="hidden md:flex items-center space-x-4">
                <Link
                  to="/privacy-policy"
                  className="text-text-secondary hover:text-primary text-sm font-body transition-colors duration-200"
                >
                  Privacy
                </Link>
                <Link
                  to="/terms-of-service"
                  className="text-text-secondary hover:text-primary text-sm font-body transition-colors duration-200"
                >
                  Terms
                </Link>
                <Link
                  to="/sitemap"
                  className="text-text-secondary hover:text-primary text-sm font-body transition-colors duration-200"
                >
                  Site Map
                </Link>
              </div>
            </div>

            <div className="flex items-center space-x-4 text-text-secondary text-sm">
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} />
                <span className="font-body">Serving 25+ Major Cities</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Phone" size={16} />
                <span className="font-body">(555) 123-4567</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;